"use client";
import { useSearchParams, usePathname } from "next/navigation";
import Modal from "react-bootstrap/Modal";
import styles from "./modal.module.scss";
import Button from "react-bootstrap/Button";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useRouter } from "next/navigation";
import { toast } from "react-toastify";
import { createOrUpdateFeedback } from "@/app/(report)/actions";

function FeedbackModal() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const modal = searchParams.get("modal");
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");
  const [comments, setComments] = useState("");
  const [show, setShow] = useState(!!modal);
  const handleClose = () => router.back();

  useEffect(() => {
    setShow(!!modal);
  }, [modal]);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    setMessage("");
    setMessage("Processing...");

    try {
      const response = await createOrUpdateFeedback(subject, comments);

      if (response) {
        setMessage("");
        setSubject("");
        setComments("");
        toast.success("Thank you for your feedback");
        handleClose();
      }
    } catch (error) {
      console.error(error);
      toast.error("Error: Failed to send your feedback");
    }
  };

  return (
    <>
      {modal && (
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Feedback or reporting a bug?</Modal.Title>
          </Modal.Header>
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <Form.Group className="tw-mb-4" controlId="subject">
                <Form.Label>Feature or page</Form.Label>
                <Form.Control
                  type="text"
                  className="tw-mt-1"
                  placeholder="e.g. on maps page..."
                  autoFocus
                  value={subject}
                  onChange={(event) => {
                    setSubject(event.target.value);
                  }}
                  required
                />
              </Form.Group>
              <Form.Group controlId="comments">
                <Form.Label>Comments</Form.Label>
                <Form.Control
                  as="textarea"
                  className="tw-mt-1"
                  rows={4}
                  placeholder="type text here..."
                  value={comments}
                  onChange={(event) => {
                    setComments(event.target.value);
                  }}
                  required
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <div className={styles.modalFooter}>
                <Button variant="outline-primary" onClick={handleClose}>
                  Close
                </Button>
                <Button variant="primary" type="submit">
                  Send
                </Button>{" "}
              </div>
              <div>{message}</div>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </>
  );
}

export default FeedbackModal;
